import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FcpButtonModule } from '../fcp-button/fcp-button.module';
import { FcpIconModule } from '../fcp-icon';
import { FcpInputModule } from '../fcp-input';
import { FcpTableRowComponent } from './fcp-table-row.component';

@NgModule({
    declarations: [FcpTableRowComponent],
    imports: [CommonModule, FcpButtonModule, FcpIconModule, FcpInputModule, FormsModule, ReactiveFormsModule],
    exports: [FcpTableRowComponent]
})
export class FcpTableRowModule {}
